export type TrainingContext = {
  /** Current route path, e.g. "/app/manager/reservations". */
  route: string;
  /** Resolved current user, or null when unauthenticated. */
  user: { role: string | null } | null;
  /** Returns true if a selector matches a visible element. */
  dom: (selector: string) => boolean;
};

export type TrainingPredicate = (ctx: TrainingContext, ...args: (string | number | boolean)[]) => boolean;

export type PredicateRegistry = Record<string, TrainingPredicate>;

export const predicateRegistry: PredicateRegistry = {
  "dom.visible": (ctx, selector) => ctx.dom(String(selector)),
  "route.is": (ctx, path) => ctx.route === String(path),
  "user.role_is": (ctx, role) => ctx.user?.role === String(role),
};
